import React, { Component } from "react";

export default class NoDataFoundIndicator extends Component {
  render() {
    return (
      <div
        className="col-lg-12"
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: this.props.marginTop,
          backgroundColor: `${this.props.backgroundColor ?? "#ffffff"}`,
        }}
      >
        <h1>No data found</h1>
      </div>
    );
  }
}
